/**
 * SCD Lot 0 — Appels d'offres « convoi exceptionnel » (SCD) vidés.
 * Exports conservés pour compatibilité avec tenderSlice / convoyExceptionnelSlice.
 */
import { MISSION_ARCHETYPES_FOR_TENDERS } from './exceptionalArchetypes';

export const EXCEPTIONAL_TENDERS = [];

export function isPlayerEligibleForExceptionalTender(_state) {
  // Plus aucun tender exceptionnel dans SCD.
  return false;
}

// Re-export pour les helpers/tests.
export { MISSION_ARCHETYPES_FOR_TENDERS };
